import React from 'react'

import { StyledBadge } from '../UserInfo/styles'

import useStyles from './styles'

interface MessageSkeletonProps {
  isYours?: boolean
}

const MessageSkeleton: React.FC<MessageSkeletonProps> = ({ isYours }) => {
  const classes = useStyles({ isYours })

  return (
    <div className={classes.root}>
      <StyledBadge overlap='rectangular' className={classes.avatarLoading}>
        <span></span>
      </StyledBadge>

      <div className={classes.msgContent}></div>
    </div>
  )
}
export default React.memo(MessageSkeleton)
